import { CompendaStatus, CompendaEventDetail } from './constants'

export default (opened: () => void, closed: () => void, notFound: () => void) => {
    const handlers = {
        [CompendaStatus.Opened]: opened,
        [CompendaStatus.Closed]: closed,
        [CompendaStatus.NotFound]: notFound,
    }

    document.addEventListener('compenda', (event: Event) => {
        const detail = (event as CustomEvent<CompendaEventDetail>).detail
        handlers[detail.status]()
    })
}
